import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardElementByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardElementByIdController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
const GetTemplateDashboardElementByIdController = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardElementByIdController.url(args, options),
    method: 'get',
})

GetTemplateDashboardElementByIdController.definition = {
    methods: ["get","head"],
    url: '/api/template-dashboard/{template_dashboard}/{element}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardElementByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardElementByIdController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
GetTemplateDashboardElementByIdController.url = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
            element: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
        element: args.element,
    }

    return GetTemplateDashboardElementByIdController.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace('{element}', parsedArgs.element.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardElementByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardElementByIdController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
GetTemplateDashboardElementByIdController.get = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardElementByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardElementByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardElementByIdController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
GetTemplateDashboardElementByIdController.head = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTemplateDashboardElementByIdController.url(args, options),
    method: 'head',
})

export default GetTemplateDashboardElementByIdController